export default{
    facetMapper:[
        {label:'Topics',key:'topic'}
        ,{label:'Sentiments',key:'sentiments'}
        ,{label:'Batch Id',key:'batch_id'}
    ]
};